import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import { prop } from '@ipfabric/utils/fp/prop';
import { Button } from 'components/Button/Button';
import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { OverlayModal } from 'components/OverlayModal/OverlayModal';
import { OverlayModalBody } from 'components/OverlayModal/OverlayModalBody';
import { OverlayModalFooter } from 'components/OverlayModal/OverlayModalFooter';
import { OverlayModalHeader } from 'components/OverlayModal/OverlayModalHeader';
import { useLocale } from 'containers/App/LocaleContext';
import { useFormik } from 'formik';
import type { FC } from 'react';
import { makeFormikOnSubmit } from 'utils/formik/makeFormikOnSubmit';
import { useApiTableContextSelectors } from '../model/ApiTableModel';
import { saveFilter } from '../model/commands/saveFilter';

interface Props {
  onClose: () => void;
  loadTableSettings: () => void;
}

export const ApiTableSaveFilterModal: FC<Props> = (props) => {
  const {
    apiTable: {
      advancedFilter: { saveFilterModal: saveFilterModalMsg },
    },
  } = useLocale();
  const [loadingState, setLoadingState] = useLoadingState();
  const ctxProps = useApiTableContextSelectors({
    dispatch: prop('dispatch'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
    },
    validate: (values) =>
      values.name === '' ? { name: saveFilterModalMsg.required } : {},
    onSubmit: makeFormikOnSubmit((values) => {
      withLoadingIndicator(setLoadingState)(async () => {
        await ctxProps.dispatch(saveFilter, { name: values.name });
        props.loadTableSettings();

        props.onClose();
      });
    }),
  });

  return (
    <OverlayModal onClose={props.onClose}>
      <form onSubmit={formik.handleSubmit}>
        <OverlayModalHeader>
          <h4>{saveFilterModalMsg.title}</h4>
        </OverlayModalHeader>
        <OverlayModalBody>
          <FormikTextField
            name='name'
            formik={formik}
            label='Filter name'
            type='text'
          />
        </OverlayModalBody>
        <OverlayModalFooter>
          <Button
            className='mr-2'
            type='submit'
            variant='primary'
            loading={loadingState === 'LOADING'}
            disabled={loadingState !== 'INITIAL'}
          >
            {saveFilterModalMsg.saveBtn}
          </Button>
          <Button
            variant='secondary'
            type='button'
            onClick={() => {
              props.onClose();
            }}
            disabled={loadingState !== 'INITIAL'}
          >
            {saveFilterModalMsg.cancel}
          </Button>
        </OverlayModalFooter>
      </form>
    </OverlayModal>
  );
};
